import { render, staticRenderFns } from "./goblet.vue?vue&type=template&id=bdbcba64&"
import script from "./goblet.vue?vue&type=script&lang=js&"
export * from "./goblet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports